import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import utils from '../../../util/Util';
import { Row, Label, FormGroup, Col } from 'reactstrap';
import TableGrid from '../../../components/tableGrid/TableGrid'
import { GetClaimDetail, PrintClaim } from '../../../redux/actions/HttpRequest';
import consts from '../../../util/Consts';
import LoadingDialog from '../../../components/loadingDialog/LoadingDialog';
import './ClaimDetails.css';

class ClaimDetails extends PureComponent {

    Columns = [
        { name: '', key: 'check loss code', type: 'checkbox' },
        { name: 'DESCRIPTION', key: 'description' },
        { name: 'MANUFACTURE', key: 'mfg' },
        { name: 'MODEL', key: 'model' },
        { name: 'SERIAL', key: 'serial' },
        { name: 'COST', key: 'cost', type: 'currency' },
        { name: 'QTY', key: 'qty' },
        { name: 'LIAB.', key: 'liab', type: 'currency' },
        { name: 'LOSS CODE', key: 'code' },
        { name: 'SERVICER', key: 'servicer' },
        { name: 'REPLACE', key: 'replace', type: 'checkbox' }
    ]

    CommentColumns = [
        { name: '', key: 'arrow', width: "45px" },
        { name: 'DATE', key: 'date', width: "145px" },
        { name: 'TYPE', key: 'commentReason', width: "95px" },
        { name: 'COMMENT', key: 'comment', width: "600px" },
        { name: 'AMOUNT', key: 'amount', type: 'currency', width: "85px" },
        { name: '', key: 'viewButton', type: 'viewButton', width: "65px" }
    ]

    constructor(props) {
        super(props);
        const isSessionEmpty = sessionStorage.length;
        if (isSessionEmpty === 0) {
            this.props.history.replace("/");
        }
        this.state = {
            showSideFilter: false,
            CommentDetails: false,
            Data: [],
            isFetching: true
        }

        this.ClaimRedirectFrom = sessionStorage.getItem(consts.sessionVariables.ClaimRedirectFrom);

        this.ClaimNumber = sessionStorage.getItem(consts.sessionVariables.ClaimNumber);
        this.props.dispatch(GetClaimDetail.request({}, 'ClaimNumber=' + this.ClaimNumber, "GET"));

        this.printReceipt = this.printReceipt.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.GetClaimDetail && nextProps.GetClaimDetail.data && nextProps.GetClaimDetail.data !== this.props.GetClaimDetail.data) {
            const { data } = nextProps.GetClaimDetail.data;
            this.setState({ Data: data, isFetching: false });
        }

        if (nextProps.PrintClaim && nextProps.PrintClaim.data && nextProps.PrintClaim.data !== this.props.PrintClaim.data) {
            const { data } = nextProps.PrintClaim.data;
            if (window.navigator && window.navigator.msSaveOrOpenBlob) { // for IE
                utils.downloadFile(data, 'pdf', 'POList_');
            } else this.printPreview(data);
        }
    }

    onRowClick = () => {
        console.log("onRowClick Claim details");
    }

    navigate = () => {
        this.props.history.push(this.ClaimRedirectFrom);
    }

    printPreview = (data, type = 'application/pdf') => {
        let blob = null;
        blob = this.b64toBlob(data, type);
        const blobURL = URL.createObjectURL(blob);
        const theWindow = window.open(blobURL);
        if (theWindow) {
            const theDoc = theWindow.document;
            const theScript = document.createElement('script');
            function injectThis() {
                window.print();
            }
            theScript.innerHTML = `window.onload = ${injectThis.toString()};`;
            theDoc.body.appendChild(theScript);
        }
    };

    b64toBlob = (content, contentType) => {
        contentType = contentType || '';
        const sliceSize = 512;
        // method which converts base64 to binary
        const byteCharacters = window.atob(content);

        const byteArrays = [];
        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);
            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        const blob = new Blob(byteArrays, {
            type: contentType
        }); // statement which creates the blob
        return blob;
    };

    printReceipt() {
        this.props.dispatch(PrintClaim.request({}, 'ClaimNumber=' + this.ClaimNumber, "GET"));
    }

    render() {
        let { Data, isFetching } = this.state;

        return (
            <Row className="justify-content-center  inner-container pt-3">
                <LoadingDialog isOpen={isFetching}></LoadingDialog>

                <section id="claims-section" className="claims-section">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="heading-flex">
                                    <h1 className="section-title darkcolor font-main mb-4">Claim Details</h1>
                                    <div className="button-wrapp mb-3">

                                        <span onClick={this.printReceipt} className="hide-on-print btn-web btn-export mb-2 ms-4 pointer">
                                            <img alt="print" src={require('.././../../assets/images/print.png').default} /> PRINT CLAIM
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="row detail-list mb-30">
                                    <div className="col-lg-4 detail-column">
                                        <div className="column-head">
                                            <Row className="claim-number claim-head">
                                                <Col md={6} className="font-main mb-0">Certificate</Col>
                                                <Col md={6} className="font-main mb-0"><span className="floatLeft" >{Data?.certificate}</span></Col>
                                            </Row>
                                        </div>
                                        <div className="detail-name">
                                            <h2 className="font-main person-name color-default mb-3 ">{Data?.name}</h2>
                                            <p className="person-address font-main  mb-0">{Data?.address}</p>
                                            <p className="person-address font-main mb-3 mt-1 ">{Data?.city} {Data?.city ? ', ' : ''} {Data?.state} {Data && Data.zip ? Data.zip.slice(0, 5) : ''}</p>
                                            <Row className="claim-number mb-2">
                                                <Col md={6} className="font-main mb-0">Cell</Col>
                                                <Col md={6} className="font-main mb-0"><span className="floatLeft" >{Data.cell ? Data.cell : '-'}</span></Col>
                                            </Row>
                                            <Row className="claim-number mb-2">
                                                <Col md={6} className="font-main mb-0">Work</Col>
                                                <Col md={6} className="font-main mb-0"><span className="floatLeft" >{Data.work ? Data.work : '-'}</span></Col>
                                            </Row>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 detail-column claim-col">
                                        <div className="column-head">
                                            <Row className="claim-number claim-head">
                                                <Col md={6} className="font-main mb-0">Claim# </Col>
                                                <Col md={6} className="font-main mb-0"><span className="floatLeft" >{Data?.claimNumber}</span></Col>
                                            </Row>
                                        </div>
                                        <div className="detail-name">
                                            <Row className="claim-number mb-2">
                                                <Col md={6} className="font-main mb-0">Purchase Date</Col>
                                                <Col md={6} className="font-main mb-0"><span className="floatLeft" >{Data?.purchaseDate}</span></Col>
                                            </Row>
                                            <Row className="claim-number mb-2">
                                                <Col md={6} className="font-main mb-0">Delivery</Col>
                                                <Col md={6} className="font-main mb-0"><span className="floatLeft" >{Data.delivery ? Data.delivery : '-'}</span></Col>
                                            </Row>
                                            <Row className="claim-number mb-2">
                                                <Col md={6} className="font-main mb-0">Limit Liab</Col>
                                                <Col md={6} className="font-main mb-0"><span className="floatLeft" >{Data.limitLiab ? '$' + Data.limitLiab : '-'}</span></Col>
                                            </Row>
                                            <Row className="claim-number mb-2">
                                                <Col md={6} className="font-main mb-0">Retail ESC</Col>
                                                <Col md={6} className="font-main mb-0"><span className="floatLeft" >{Data.retailESC ? Data.retailESC : '-'}</span></Col>
                                            </Row>
                                            <Row className="claim-number mb-2">
                                                <Col md={6} className="font-main mb-0">Term</Col>
                                                <Col md={6} className="font-main mb-0"><span className="floatLeft" >{Data.term ? Data.term : '-'}</span></Col>
                                            </Row>
                                            <Row className="claim-number">
                                                <Col md={6} className="font-main mb-0">Service Type</Col>
                                                <Col md={6} className="font-main mb-0"><span className="floatLeft" >{Data.serviceType ? Data.serviceType : '-'}</span></Col>
                                            </Row>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 detail-column claim-col">

                                        <div className="column-head">
                                            <Row className="claim-number claim-head">
                                                <Col md={6} className="font-main mb-0">Status</Col>
                                                <Col md={6} className="font-main mb-0"><span className={`floatLeft ${Data.status === 'Completed' ? 'color-success' : Data.status ==='Declined' ? 'color-danger' : 'color-default'} `} >{Data?.status}</span></Col>
                                            </Row>
                                        </div>
                                        <div className="detail-name">
                                            <Row className="claim-number mb-2">
                                                <Col md={6} className="font-main mb-0">Invoice#</Col>
                                                <Col md={6} className="font-main mb-0"><span className="floatLeft" >{Data?.invoiceNumber}</span></Col>
                                            </Row>
                                            <Row className="claim-number mb-2">
                                                <Col md={6} className="font-main mb-0">Carrier</Col>
                                                <Col md={6} className="font-main mb-0"><span className="floatLeft" >{Data.carrier ? Data.carrier : '-'}</span></Col>
                                            </Row>
                                            <Row className="claim-number mb-2">
                                                <Col md={6} className="font-main mb-0">Dealer</Col>
                                                <Col md={6} className="font-main mb-0"><span className="floatLeft" >{Data?.dealer}</span></Col>
                                            </Row>
                                            <Row className="claim-number">
                                                <Col md={6} className="font-main mb-0">Product</Col>
                                                <Col md={6} className="font-main mb-0"><span className="floatLeft" >{Data.product ? Data.product : '-'}</span></Col>
                                            </Row>
                                        </div>
                                    </div>
                                </div>
                                <div className="mb-3">
                                    <TableGrid
                                        screenName={false}
                                        Data={Data.items}
                                        Columns={this.Columns}
                                        tableClassName="table-web"
                                        disabled={true}
                                        AddComment={false}
                                    ></TableGrid>
                                </div>
                                <div className="customer-box mb-30">
                                    <div className="row">
                                        <div className="col-xl-4 col-lg-5">
                                            <div className="flex-customer">
                                                <p className="font-main mb-0 ">Loss Date</p>
                                                <p className="font-main mb-0 padding-Col ">{Data?.lossDate ? Data.lossDate : '-'}</p>
                                            </div>
                                            <div className="flex-customer mt-10">
                                                <p className="font-main mb-0 ">Claim Notification Date</p>
                                                <p className="font-main mb-0 padding-Col">{Data?.claimNotDate ? Data.claimNotDate : '-'}</p>
                                            </div>
                                            <div className="flex-customer mt-10">
                                                <p className="font-main mb-0 ">Schedule Date</p>
                                                <p className="font-main mb-0 padding-Col">{Data?.scheduleDate ? Data.scheduleDate : '-'}</p>
                                            </div>
                                            <div className="flex-customer mt-10">
                                                <p className="font-main mb-0 ">Close Date</p>
                                                <p className="font-main mb-0 padding-Col">{Data?.closeDate ? Data.closeDate : '-'}</p>
                                            </div>
                                            <div className="flex-customer mt-10">
                                                <p className="font-main mb-0 ">Type</p>
                                                <p className="font-main mb-0 padding-Col">{Data?.type ? Data.type : '-'}</p>
                                            </div>
                                            <div className="flex-customer mt-10">
                                                <p className="font-main mb-0 ">Setup Date</p>
                                                <p className="font-main mb-0 padding-Col">{Data?.setupDate ? Data.setupDate : '-'}</p>
                                            </div>
                                            <div className="flex-customer mt-10">
                                                <p className="font-main mb-0 ">Manufacturer Parts</p>
                                                <p className="font-main mb-0 padding-Col">{Data?.mfgParts ? Data.mfgParts : '-'}</p>
                                            </div>
                                            <div className="flex-customer mt-10">
                                                <p className="font-main mb-0 ">Labor</p>
                                                <p className="font-main mb-0 padding-Col">{Data?.labor ? Data.labor : '-'}</p>
                                            </div>
                                           
                                        </div>
                                        <div className="col-xl-8 col-lg-7">
                                            <form className="form-customer-detail">
                                                <FormGroup className="mb-3">
                                                    <Label for="NarrativeMsg">Customer Narrative</Label>
                                                    <textarea id="NarrativeMsg"
                                                        disabled={true}
                                                        value={Data.customerNarrative}
                                                        className="form-control"
                                                    ></textarea>
                                                </FormGroup>
                                                <FormGroup>
                                                    <Label for="AuthorizedWrk">Authorized Work</Label>
                                                    <textarea id="AuthorizedWrk"
                                                        disabled={true}
                                                        value={Data.authWork}
                                                        className="form-control"></textarea>
                                                </FormGroup>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                                <div className="mb-2">
                                    <TableGrid
                                        screenName={false}
                                        tableName="Comments"
                                        showAmount={false}
                                        onRowClick={this.onRowClick}
                                        Data={Data.comments}
                                        Columns={this.CommentColumns}
                                        handleModal={this.handleModal}
                                        tableClassName="table-detail detail-summery"
                                    ></TableGrid>
                                </div>

                                <div className="heading-flex">
                                    <span onClick={this.navigate} className="hide-on-print btn-darker btn-export mb-2 ms-1 pointer">
                                        <img alt="export" src={require('.././../../assets/images/back.png').default} /> BACK
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </Row>
        );
    }
}

function mapStateToProps(state) {
    return {
        GetClaimDetail: state.GetClaimDetail,
        PrintClaim: state.PrintClaim
    };
}

var ClaimDetailsModule = connect(mapStateToProps)(ClaimDetails);
export default ClaimDetailsModule;